import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { MonitoringNotificationsModel } from '../../../../models/monitoring-notification';
import { HandlingUnitEndpoint } from '../../constants/handling-unit-endpoint';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitNotificationsService {
  constructor(private http: WrapperHttpService) {}

  getNotifications({
    deliveryNoteNumber,
    handlingUnitNumber,
  }: {
    deliveryNoteNumber: string;
    handlingUnitNumber: string;
  }): Observable<MonitoringNotificationsModel[]> {
    return this.http
      .withLoading()
      .get<MonitoringNotificationsModel[]>(
        `${API_URL}${HandlingUnitEndpoint.Base}${HandlingUnitEndpoint.Monitoring}${HandlingUnitEndpoint.DeliveryNote}/${deliveryNoteNumber}${HandlingUnitEndpoint.HandlingUnit}/${handlingUnitNumber}${HandlingUnitEndpoint.Notifications}`,
      );
  }
}
